import { render, staticRenderFns } from "./UHowToUse.vue?vue&type=template&id=38bd4635&scoped=true&"
import script from "./UHowToUse.vue?vue&type=script&lang=ts&"
export * from "./UHowToUse.vue?vue&type=script&lang=ts&"
import style0 from "./UHowToUse.vue?vue&type=style&index=0&id=38bd4635&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd4635",
  null
  
)

export default component.exports